/**
 * Parseia contact.others (JSON) e retorna todos os campos extras.
 * Um único parse por contato; usado na cópia e no modal.
 * Os campos extras são descobertos dos dados (ex.: LOJA_DE_PREFERENCIA, MARCA_DE_PREFERENCIA).
 */

/**
 * Retorna todos os pares chave-valor do JSON em contact.others.
 * Chaves mantêm o formato do backend (ex.: LOJA_DE_PREFERENCIA, loja_de_preferencia).
 * Valores são strings trimadas; chaves com valor vazio/null/undefined são omitidas.
 */
export function getExtraFields(
  others: string | undefined,
): Record<string, string> {
  const result: Record<string, string> = {};
  if (!others || typeof others !== "string") return result;
  try {
    const parsed = JSON.parse(others) as Record<string, unknown>;
    if (!parsed || typeof parsed !== "object") return result;
    for (const [key, value] of Object.entries(parsed)) {
      if (value == null) continue;
      const str = String(value).trim();
      if (str !== "") result[key] = str;
    }
  } catch {
    // ignore
  }
  return result;
}

/**
 * Coleta todas as chaves únicas de campos extras a partir de uma lista de contatos.
 * Usado na tela de configuração para mostrar quais extras existem na campanha.
 */
export function getAllExtraKeysFromContacts(
  contacts: { others?: string }[],
): string[] {
  const keys = new Set<string>();
  for (const c of contacts) {
    const extras = getExtraFields(c.others);
    Object.keys(extras).forEach((k) => keys.add(k));
  }
  return Array.from(keys).sort();
}
